import script from "./BlueprintEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueprintEditor.vue?vue&type=script&setup=true&lang=js"

import "./BlueprintEditor.vue?vue&type=style&index=0&id=5246484f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5246484f"]])

export default __exports__